<template>
    <v-layout justify-center class="pa-4">
        <v-responsive width="100%" height="100%">
            <list-heading title="보증금 내역" v-model="showsSearch" showsFilterButton>
                <template #add-button>
                    <deposit-form isCreate @input="search">
                        <template #activator="{ attrs, on }">
                            <v-btn text icon tile color="primary" v-bind="attrs" v-on="on"> <v-icon>mdi-plus</v-icon> </v-btn>
                        </template>
                    </deposit-form>
                </template>
            </list-heading>

            <list-search-default
                v-bind="{
                    showsSearch,
                    loading,
                    searchKeys,
                }"
                v-on="{ search }"
            />

            <v-row class="ma-n2 mt-n1">
                <v-col class="pa-2" cols="auto">
                    <deposit-list-type />
                </v-col>
                <v-col class="pa-2" cols="auto">
                    <deposit-list-member />
                </v-col>
                <v-spacer />
                <v-col class="pa-2" cols="auto">
                    <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                        <v-card outlined style="overflow: hidden;">
                            <v-btn color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                <v-icon> mdi-microsoft-excel </v-icon>
                                <span> 엑셀다운로드 </span>
                            </v-btn>
                        </v-card>
                    </list-excel>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" ref="data-table">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="my-2" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/lib";

import ListExcel from "@/components/console/dumb/list/list-excel.vue";
import ListHeading from "@/components/console/dumb/list/list-heading.vue";
import ListSearchDefault from "@/components/console/dumb/list/list-search-default.vue";
import DepositForm from "@/components/console/user/deposit-form.vue";
import DepositListMember from "@/components/console/user/deposit-list-member.vue";
import DepositListType from "@/components/console/user/deposit-list-type.vue";

const headers = initDataTableHeaders([
    {
        text: "순번",
        value: "index",
        width: 100,
        align: "end",
        formatterType: "number",
    },
    {
        text: "유형",
        value: "type",
        width: 120,
        formatter: (value) => ({ DECREASE: "출금", INCREASE: "입금" }[value] || "-"),
    },
    {
        text: "회원 (ID/이름)",
        value: "member",
        width: 240,
        formatter: ({ username, name } = {}) => `${username} / ${name}`,
    },
    {
        text: "금액",
        value: "amount",
        formatterType: "number",
        formatterSuffix: "원",
        width: 240,
    },
    {
        text: "잔액",
        value: "remain",
        formatterType: "number",
        formatterSuffix: "원",
        width: 240,
    },
    {
        text: "비고",
        value: "remark",
    },
    {
        text: "생성일시",
        value: "createdAt",
        formatterType: "datetime",
        width: 180,
    },
]);

const searchKeys = [
    //
    { text: "비고", value: "remark" },
];

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearchDefault,
        DepositForm,
        DepositListMember,
        DepositListType,
    },
    data: () => ({
        deposits: [],

        limit: 20,
        summary: { totalCount: 0 },

        headers,
        searchKeys,

        loading: false,
        showsSearch: true,
    }),
    computed: {
        items() {
            return this.deposits.map((item, index) => ({
                ...item,
                index: this.summary.totalCount - index - this.skip,
            }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            return { ...query };
        },
    },
    methods: {
        async init() {
            this.deposits = [];
            this.summary = { totalCount: 0 };
            this.loading = false;

            await this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                let { summary, deposits } = await api.console.deposits.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.deposits = deposits;
            } finally {
                this.loading = false;
            }
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                let { deposits } = await api.console.deposits.gets({
                    headers: { skip, limit },
                    params,
                });

                let { headers } = this;
                let fileName = "보증금_정책";
                this.$excel(deposits, headers, fileName);
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
